import React from 'react';
import { useTranslation } from 'react-i18next';
import { withLinkStore } from '../app/reducers';

const SessionExpired = (props) => {
    const { t } = useTranslation();
    const { viewerSetting } = props.linkStore;

    const renewSession = () => {
        window.location.reload();
    };

    return (
        <div className="seismic-engagement-viewer-session-expired">
            <div className="seismic-engagement-viewer-session-expired-header">
                {viewerSetting.logo && <img className="custom-logo" src={viewerSetting.logo} alt="logo" />}
            </div>
            <div className="seismic-engagement-viewer-session-expired-content">
                <div className="session-expired-msg">{t('LIVE_SEND_VIEWER_SESSION_EXPIRED')}</div>
                <button className="enagement-buyer-btn btn-active btn-renew-session"
                    style={{ backgroundColor: viewerSetting.brandingHilightColor }}
                    onClick={renewSession}>
                    {t('LIVE_SEND_VIEWER_RENEW_SESSION')}
                </button>
            </div>
        </div>
    );
};

export default withLinkStore(SessionExpired);
